import { inject } from '@angular/core';
import { SvgRegistry } from '@ui/components/svg';

export function registerSvgAssets(): void {
  const registry = inject(SvgRegistry);

  registry.add('three-papers', '/media/images/three-papers.svg');
  registry.add('three-papers-dark', '/media/images/three-papers-dark.svg');
  registry.add('kyc-awaiting-verification', '/media/images/kyc-awaiting-verification.svg');
  registry.add('kyc-awaiting-verification-dark', '/media/images/kyc-awaiting-verification-dark.svg');
  registry.add('linked-accounts', '/media/images/linked-accounts.svg');
  registry.add('linked-accounts-dark', '/media/images/linked-accounts-dark.svg');
  registry.add('card-placeholder', '/media/images/card.svg');
  registry.add('tether', '/media/images/tether.svg');
}
